#import "../fragments/StudioFragment.gql"
query Studio($id: ID!) {
  findStudio(id: $id) {
    ...StudioFragment
    sub_studios {
      count
    }
  }
}
